import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e3a0bc6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "apply-title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "发票申请", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-arrow-right-svg" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "请选择发票抬头", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-arrow-right-svg" }, null, -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "invoice-info"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, "*仅提供电子发票", -1))
const _hoisted_10 = {
  key: 0,
  class: "footer xag-page__footer nongfu-button-wrap"
}

import { Button } from 'vant'
import { useRouter, useRoute } from 'vue-router'
import { Ref, ref, computed } from 'vue'
import { PayOrderDetail } from '@/types/jijia'
import { getThousandMoney } from '@/utils/index'
import { getJijiaOrderDetail, applyJijiaOrderInvoice } from '@/apis/jijia'
import { ConfirmUseStorageData } from '@/types/invoice'
import { useUsermobileInfo } from '@/compositions/common'
import { CacheSelectJijiaOrderInfoKey } from '@/config/jijia'
import { showToastLoading, clearToast, showConfirmModal, showToastFail } from '@/utils/tools'
import { confirmUseInvoiceStorageKey, invoiceNewTypeTextMap } from '@/views/invoice/definition'
import AppHeader from '@/components/Header.vue'
import BaseInfoList from './components/base-info-list.vue'
import DevicePayInfo from './components/device-pay-info.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'apply-invoice',
  setup(__props) {

const detail: Ref<PayOrderDetail | null> = ref(null)
const { userMobileComputed } = useUsermobileInfo()
const $router = useRouter()
const $route = useRoute()
const routeQuery = $route.query
const cacheKey = CacheSelectJijiaOrderInfoKey + routeQuery.guid
const costInfoStyle = {
  fontWeight: 'bold',
}
const confirmUseInvoiceStorageData: ConfirmUseStorageData | null = JSON.parse(
  sessionStorage.getItem(confirmUseInvoiceStorageKey)
)
const cacheDetailStoarageData: PayOrderDetail | null = JSON.parse(sessionStorage.getItem(cacheKey))
const invoiceInfo = ref(
  confirmUseInvoiceStorageData?.needInvoice && confirmUseInvoiceStorageData?.invoice
    ? [
        { label: '发票抬头', value: confirmUseInvoiceStorageData?.invoice?.header },
        { label: '发票税号', value: confirmUseInvoiceStorageData?.invoice?.taxpayer_no },
        {
          label: '发票类型',
          value: invoiceNewTypeTextMap.get(confirmUseInvoiceStorageData?.invoice?.invoice_type),
        },
      ]
    : []
)
const smsMessageInfo = computed(() => {
  return [{ label: '短信通知  ', value: userMobileComputed.value }]
})
const hasInvoiceInfo = computed(() => {
  return invoiceInfo.value.length
})
function selectInvoice() {
  sessionStorage.setItem(cacheKey, JSON.stringify(detail.value))
  $router.push({
    name: 'invoice-confirm-new',
  })
}
async function submitInvoiceApply() {
  try {
    await showConfirmModal({
      message: '是否确认提交发票申请?',
      className: 'repair-dialog',
    })
    showToastLoading()
    const params = {
      invoice_guid: confirmUseInvoiceStorageData.invoice.guid,
      invoice_type: '1',
    }
    await applyJijiaOrderInvoice(routeQuery.guid as string, params)
    clearToast()
    $router.go(-1)
  } catch (error) {
    console.log('error', error)
    if (error) {
      const message = error?.message || '申请失败'
      showToastFail(message)
    }
  }
}
async function initPageDetail() {
  if (cacheDetailStoarageData) {
    detail.value = cacheDetailStoarageData
    return
  }
  showToastLoading()
  try {
    const data = await getJijiaOrderDetail(routeQuery.guid as string)
    console.log('data', data)
    const equipment = data.equipment
    const needVerify = data.event_type === 'out_insurance_buy'
    const costInfo = [
      {
        label: '2022 极加服务 服务费',
        value: '¥6,000',
        valueStyle: costInfoStyle,
      },
    ]
    if (data.refunded_amount) {
      costInfo.push({
        label: '退款金额',
        value: `¥${getThousandMoney(data.refunded_amount)}`,
        valueStyle: costInfoStyle,
      })
    }
    if (needVerify) {
      costInfo.push({
        label: '验机服务费',
        value: '¥500',
        valueStyle: costInfoStyle,
      })
    }
    detail.value = {
      deviceCommonInfo: {
        img: equipment.logo,
        name: equipment.name,
        sequence: equipment.serial_number,
      },
      serviceInfoList: [
        {
          label: '设备型号',
          value: equipment.product_definition_name,
        },
        {
          label: '保障服务时间',
          value: '服务期1年',
        },
        {
          label: '是否需要验机',
          value: needVerify ? '是' : '否',
        },
      ],
      costInfo,
      buyInfo: {
        price: getThousandMoney(data.pay_amount - data.refunded_amount),
        title: '开票金额',
      },
    }
  } catch (error) {
    console.log('error', error)
  }
  clearToast()
}

initPageDetail()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: "发票申请" }),
    _createElementVNode("section", _hoisted_1, [
      _createVNode(DevicePayInfo, { detail: detail.value }, null, 8, ["detail"]),
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        (_unref(hasInvoiceInfo))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "choose-again",
              onClick: selectInvoice
            }, [
              _createTextVNode(" 重新选择"),
              _hoisted_4
            ]))
          : _createCommentVNode("", true)
      ]),
      (!_unref(hasInvoiceInfo))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "cell",
            onClick: selectInvoice
          }, _hoisted_7))
        : _createCommentVNode("", true),
      (_unref(hasInvoiceInfo))
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(BaseInfoList, {
              list: invoiceInfo.value,
              class: "van-hairline--top",
              listItemMt: 8
            }, null, 8, ["list"]),
            _createVNode(BaseInfoList, {
              list: _unref(smsMessageInfo),
              class: "van-hairline--top"
            }, null, 8, ["list"])
          ]))
        : _createCommentVNode("", true),
      _hoisted_9
    ]),
    (detail.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createVNode(_unref(Button), {
            class: "xa-vant-button",
            onClick: submitInvoiceApply,
            block: "",
            round: "",
            type: "success",
            disabled: !_unref(hasInvoiceInfo)
          }, {
            default: _withCtx(() => [
              _createTextVNode("提交发票申请")
            ]),
            _: 1
          }, 8, ["disabled"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})